import { CircularProgress, DialogContent } from '@mui/material';
import { useGetHospitalById, useUpdateHospital } from '_api';
import { Hospital, HospitalPayload } from '_api/types';
import { SEVERITY } from '_constants/derived';
import { AlertMessage, BaseModal } from 'components/molecules';
import { HospitalForm } from 'components/organisms/forms';
import React, { useEffect, useState } from 'react';

import { HospitalModalProps } from './types';

export const EditHospital = ({ open, onClose, hospitalId }: HospitalModalProps) => {
  const { data: apiHospital, isLoading } = useGetHospitalById(hospitalId);
  const { mutateAsync: updateHospital } = useUpdateHospital();

  const convertToHospitalPayload = (initHospital: Hospital) => {
    const { organization, ...data } = initHospital;
    return {
      ...data,
      organizationId: organization.id,
    } as HospitalPayload;
  };

  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [hospital, setHospital] = useState(
    apiHospital ? convertToHospitalPayload(apiHospital) : undefined,
  );

  useEffect(() => {
    if (hospitalId && apiHospital) setHospital(convertToHospitalPayload(apiHospital));
  }, [apiHospital, hospitalId]);

  const onSubmit = (updatedHospital: HospitalPayload) => {
    updateHospital(updatedHospital)
      .then((data) => {
        if (data && data.id) {
          setShowSuccess(true);
          setTimeout(() => onClose(), 1500);
        }
      })
      .catch(() => setShowError(true));
  };

  return (
    <BaseModal open={open} onClose={onClose} title={'Add Hospital/Clinic'}>
      {!isLoading && hospital && hospital.id === hospitalId ? (
        <DialogContent>
          <HospitalForm
            disableAll={showSuccess}
            initValue={hospital}
            onSubmit={onSubmit}
            onBack={onClose}
          />
        </DialogContent>
      ) : (
        <CircularProgress />
      )}
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Hospital successfully updated'}
      />
      <AlertMessage
        severity={SEVERITY.error}
        open={showError}
        onClose={() => setShowError(false)}
        message={'Failed to create Hospital. Resolve form issues and try again.'}
      />
    </BaseModal>
  );
};
